"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
function default_1({ profileForm, }) {
    const { setValue, watch } = profileForm;
    const setThumbnailPreview = (compressedImg) => {
        setValue('thumbnail', URL.createObjectURL(compressedImg));
        setValue('uploadedImg', compressedImg, { shouldDirty: true });
    };
    const uploadProfileImage = (files) => {
        const imageFile = files[0];
        (0, functions_1.compressImageFile)({
            imageFile,
            maxWidth: 300,
            quality: 0.7,
            onCompressSuccess: setThumbnailPreview,
        });
    };
    const thumbnail = watch('thumbnail');
    return ((0, jsx_runtime_1.jsxs)("label", Object.assign({ role: "button", css: { paddingRight: '10px', cursor: 'pointer' } }, { children: [(0, jsx_runtime_1.jsx)(components_1.RoundImage, Object.assign({ size: 52, src: thumbnail, altSrc: `${process.env.CDN_URL}/assets/svgs/default_profile.svg` }, { children: (0, jsx_runtime_1.jsx)(svgs_1.CameraIconCircleSvg, { css: { position: 'absolute', bottom: '-3px', right: '-10px' } }) })), (0, jsx_runtime_1.jsx)("input", { id: "profile_photo_input", name: "file", type: "file", hidden: true, onChange: e => e.target.files && uploadProfileImage(e.target.files), onClick: e => {
                    (0, webview_app_1.askPhotoPermissionsToWVA)('profile_photo_input', e);
                    e.currentTarget.value = '';
                } })] })));
}
exports.default = default_1;
